// --------------------------------------------------------------
// Created On: 2022-01-24
// Author: Zachary Thomas
//
// Last Modified: 2026-10-13
// Modified By: Jonathon Hicke
//
// Copyright 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import { MAX_NOTIFICATION_MESSAGE_LENGTH } from "../../../../../constants/miscellaneous";

// Form for sending an notification message.
export default function NotificationMessageForm(props: Props): Component {
  return (
    <div className="form-notification-message mx-2 mt-3">
      <label className="mb-3">Notification Message</label>
      <textarea
        data-test="notification-message-textarea"
        className="form-control"
        rows={3}
        maxLength={MAX_NOTIFICATION_MESSAGE_LENGTH}
        value={props.notificationMessage}
        onChange={(e) => props.onChangeNotificationMessage(e.target.value)}
      />
    </div>
  );
}

interface Props {
  notificationMessage: string;
  onChangeNotificationMessage: (notificationMessage: string) => void;
}
